import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../ui/card";
import { Button } from "../../../ui/button";
import { Input } from "../../../ui/input";
import { Badge } from "../../../ui/badge";
import { Checkbox } from "../../../ui/checkbox";
import { Label } from "../../../ui/label";
import {
  Search,
  Eye,
  CheckCircle2,
  XCircle,
  Clock,
  FolderOpen,
  CheckCircle,
  Send,
  AlertCircle,
  X,
  FileDown,
  Users,
  Package,
  Upload,
  ChevronDown,
  ChevronUp,
  Paperclip,
  PauseCircle,
  Loader2,
  Filter,
  CircleAlert,
  FileUser,
  Activity,
  Tickets,
  ArrowUp,
  ArrowDown,
  ArrowUpDown,
} from "lucide-react";
import { toast } from "sonner";
// import { VisaRequestedDetailView } from "./VisaRequestedDetailView";
import { VisaRequestedDetailModel } from "../../../types/VisaRequestedDetailModel";
// import type { VisaApplicant } from "../../../types/visa";
import {
  createBatchs,
  exportBatchDocuments,
  getBatchList,
  getFilterCounts,
  getStatusHistory,
  getVisaRequestedList,
  getVisaRequestedSummary,
  NoMoreNeededBatchDocuments,
  uploadBatchCertificates,
  // getVisaApplicationById
} from "../../../services/visaService";
import useDebounce from "../../../hooks/useDebounce";
import { DraftVisaItem } from "../../../types/itsDetails";
import { FullScreenLoading } from "../../../components/ui/loader";
import Pagination from "../../../ui/pagination";
import { NoApplicantFound } from "../../../ui/noRecordfound";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../ui/select";
import { mapVisaRequestedListItem } from "../../../mappers/visaApplication.mapper";
import { Tabs, TabsList, TabsTrigger } from "@radix-ui/react-tabs";
import { getFileViewUrl } from "../../../utils/commonutils";
import ConfirmDialog from "../../../ui/ConfirmDialog";
import { ActivityLogsPage } from "../completed/ActivityLogsPage";
import { StatusHistory } from "../../../types/visa";
import { useScreenPermission } from "../../../hooks/useScreenPermission";
import { usePageHeader } from "contexts/PageHeaderContext";

interface VisaSummaryResponse {
  systemApplicants: number;
  totalBatches: number;
  exportedApplicants: number;
  applicantsOnHold: number;
}

interface Batch {
  id: string;
  batchId: string;
  batchNo: string;
  batchGuid: string;
  batchName: string;
  totalApplicants: string;
  batchNumber: string;
  createdDate: string;
  createdOn: string;
  updatedAt?: string | undefined;
  applicantCount: number;
  status: "created" | "exported" | "uploaded" | "sent" | "1";
  // applicants: VisaApplicant[];
  applicants: DraftVisaItem[];
}

interface VisaRequestedPageNewProps {
  onNavigate?: (page: string) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface VisaRequestedDetailViewProps {
  applicant: VisaRequestedDetailModel;
  onBack: () => void;
  onNavigate?: (page: string) => void;
  isInBatch?: boolean;
}

type BatchTabStatus = "pending" | "approved" | "new" | "*";

interface BatchFilterCounts {
  newCount: number;
  pendingCount: number;
  approvedCount: number;
  totalCount: number;
}

export const VisaRequestedPageNew = ({
  onNavigate,
}: VisaRequestedPageNewProps) => {
  const navigate = useNavigate();
  const { setPageHeader } = usePageHeader();
  const [isCreatingBatch, setIsCreatingBatch] = useState(false);
  const [activeTab, setActiveTab] = useState<"system" | "batch">("system");
  const [BatchactiveTab, setBatchActiveTab] = useState<BatchTabStatus>("new");
  const [systemApplicants, setSystemApplicants] = useState<DraftVisaItem[]>([]);
  const [batches, setBatches] = useState<Batch[]>([]);
  const [selectedApplicants, setSelectedApplicants] = useState<number[]>([]);
  const [expandedBatches, setExpandedBatches] = useState<string[]>([]);

  // Batch selection - track selected applicants per batch
  const [batchSelections, setBatchSelections] = useState<
    Record<string, string[]>
  >({});

  // Batch creation
  const [showBatchDialog, setShowBatchDialog] = useState(false);
  const [, setBatchName] = useState("");
  const [, setBatchRemark] = useState("");
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [batchGuidId, setBatchGuidId] = useState<string | null>();
  const [showActivityLogs, setShowActivityLogs] = useState(false);
  const [selectedApplicantForLogs, setSelectedApplicantForLogs] = useState<
    StatusHistory[]
  >([]);
  const [statushisLoader, setStatusHistoryLoader] = useState<boolean>(false);
  const [batchFilterCounts, setBatchFiltersCounts] =
    useState<BatchFilterCounts>({
      newCount: 0,
      pendingCount: 0,
      approvedCount: 0,
      totalCount: 0,
    });

  // Upload dialog
  const [isUploading, setIsUploading] = useState(false);
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [uploadingBatchId, setUploadingBatchId] = useState<string | null>(null);

  // Review & Approve dialog
  const [showReviewApproveDialog, setShowReviewApproveDialog] = useState(false);
  const [, setUploadingApplicantId] = useState<string | null>(null);

  const [batchFiles, setBatchFiles] = useState<File[]>([]);

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");

  //FILTERS
  const [showFilters, setShowFilters] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterFields, setFilterFields] = useState({
    applicantName: "",
    itsNo: "",
    passportNo: "",
    nationality: "",
    partnerName: "",
    officeName: "",
    visaId: "",
    tourRefNo: "",
    visaRequired: "",
    pageNo: 1,
    pageSize: 20,
    status: "new",
  });

  const mergedFilters = useMemo(
    () => ({
      ...filterFields,
      searchTerm,
    }),
    [filterFields, searchTerm],
  );
  const debouncedFilters = useDebounce(mergedFilters, 400);

  const [loading, setLoading] = useState(false);
  const [visaRequestedList, setVisaRequestedList] = useState<DraftVisaItem[]>(
    [],
  );
  const [totalVisaReqCount, setTotalVisaReqCount] = useState(0);
  const [totalBatchCount, setTotalBatchCount] = useState(0);
  const [dashboardSummary, setDashboardSummary] =
    useState<VisaSummaryResponse | null>(null);

  const { canAdd } = useScreenPermission();

  // API CALLING START
  const fetchVisaReqSummary = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getVisaRequestedSummary();
      setDashboardSummary(response);
    } catch (error) {
      toast.error("Failed to fetch draft visa applications");
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchVisaRequestedList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getVisaRequestedList(debouncedFilters);
      setVisaRequestedList(data.items.map(mapVisaRequestedListItem));
      setTotalVisaReqCount(data.totalCount);
    } catch {
      toast.error("Failed to fetch draft visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  const fetchBatchList = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getBatchList(debouncedFilters);
      setBatches(data);
      setTotalBatchCount(data.length);
    } catch {
      toast.error("Failed to fetch draft visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  const fetchFiltersCounts = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getFilterCounts(debouncedFilters);
      setBatchFiltersCounts(data);
    } catch {
      toast.error("Failed to fetch draft visa applications");
    } finally {
      setLoading(false);
    }
  }, [debouncedFilters]);

  useEffect(() => {
    setPageHeader({
      title: "Visa Requested",
      icon: <Tickets className="h-4 w-4" />,
      onBack: () => navigate("/visa-muwafiqa"),
    });

    return () => setPageHeader(null);
  }, [navigate, setPageHeader]);

  useEffect(() => {
    fetchVisaRequestedList();
    fetchBatchList();
    fetchVisaReqSummary();
    fetchFiltersCounts();
  }, [
    fetchVisaRequestedList,
    fetchBatchList,
    fetchVisaReqSummary,
    fetchFiltersCounts,
    isCreatingBatch,
  ]);
  // API CALLING END

  const selectableApplicantIds = visaRequestedList
    .filter((applicant) => applicant.currentStatusCode?.toLowerCase() !== "on_hold")
    .map((applicant) => Number(applicant.visaApplicationId));

  useEffect(() => {
    const heldIds = visaRequestedList
      .filter((applicant) => applicant.currentStatusCode?.toLowerCase() === "on_hold")
      .map((applicant) => Number(applicant.visaApplicationId));
    setSelectedApplicants((selected) => selected.filter((id) => !heldIds.includes(id)));
  }, [visaRequestedList]);

  // Handle select all for eligible applicants
  const handleSelectAll = () => {
    if (selectableApplicantIds.every((id) => selectedApplicants.includes(id))) {
      setSelectedApplicants([]);
    } else {
      setSelectedApplicants(selectableApplicantIds);
    }
  };

  // Handle individual selection
  const handleSelectApplicant = (applicantId: number) => {
    if (!selectableApplicantIds.includes(applicantId)) return;
    setSelectedApplicants((selected) =>
      selected.includes(applicantId)
        ? selected.filter((id) => id !== applicantId)
        : [...selected, applicantId],
    );
  };

  // HANDLE CREATE BATCHS
  const handleCreateBatch = async () => {
    const heldIds = visaRequestedList
      .filter((applicant) => applicant.currentStatusCode?.toLowerCase() === "on_hold")
      .map((applicant) => Number(applicant.visaApplicationId));
    if (selectedApplicants.some((id) => heldIds.includes(id))) {
      setSelectedApplicants((selected) => selected.filter((id) => !heldIds.includes(id)));
      toast.error("On-hold applicants cannot be added to a batch");
      return;
    }
    if (selectedApplicants.length === 0) {
      toast.error("Please select at least one applicant");
      return;
    }

    try {
      setIsCreatingBatch(true);

      const payload = {
        visaApplicationIds: selectedApplicants,
        remarks: "",
      };

      const response = await createBatchs(payload);

      // const yearSuffix = new Date().getFullYear().toString().slice(-2); // Get last 2 digits of year
      // const batchName = `GRP-${yearSuffix}-${String(response?.batchNumber).padStart(6, "0")}`;
      const batchName = `${String(response?.batchNumber).padStart(6, "0")}`;

      const selectedApplicantsData = systemApplicants
        .filter((app) => selectedApplicants.includes(Number(app.id)))
        .map((app) => ({
          ...app,
          status: "batch_added" as const,
          batchNo: response?.batchNumber,
          batchName: batchName,
        }));

      const newBatch: Batch = {
        id: `b${Date.now()}`,
        batchId: response?.batchId,
        batchNo: response?.batchNumber,
        batchNumber: response?.batchNumber,
        batchGuid: response?.batchGuid,
        batchName: batchName,
        totalApplicants: "",
        createdDate: new Date().toISOString().split("T")[0],
        createdOn: response?.createdOn
          ? response.createdOn
          : new Date().toISOString().split("T")[0],
        updatedAt: response?.updatedAt
          ? response.updatedAt
          : new Date().toISOString().split("T")[0],
        applicantCount: selectedApplicantsData.length,
        status: "created",
        applicants: selectedApplicantsData,
      };

      // Add to batches
      setBatches([newBatch, ...batches]);

      // Remove from system applicants
      setSystemApplicants(
        systemApplicants.filter(
          (app) => !selectedApplicants.includes(Number(app.id)),
        ),
      );

      toast.success(
        `Batch "${batchName}" created with ${selectedApplicants.length} applicant(s)`,
      );

      setShowBatchDialog(false);
      setBatchRemark("");
      setSelectedApplicants([]);
      fetchVisaRequestedList();
    } catch (error) {
      toast.error("Failed to create batch");
    } finally {
      setIsCreatingBatch(false);
    }
  };

  // Toggle batch accordion
  const toggleBatch = (batchId: string) => {
    if (expandedBatches.includes(batchId)) {
      setExpandedBatches(expandedBatches.filter((id) => id !== batchId));
    } else {
      setExpandedBatches([...expandedBatches, batchId]);
    }
  };

  // Batch actions with selection
  const handleExportBatchSelected = async (batch: Batch) => {
    try {
      const res = await exportBatchDocuments(Number(batch.batchId));
      const blob = new Blob([res.data], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // ✅ file name from backend header
      const contentDisposition = res.headers["content-disposition"];
      let fileName = `${batch.batchNumber}_export.zip`;

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename\*?=(?:UTF-8'')?"?([^"]+)"?/,
        );
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1]);
        }
      }

      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(url);
      toast.success(
        `Exported ${batch.totalApplicants} applicant(s) from batch ${batch.batchNumber}`,
      );
      fetchBatchList();
    } catch (error) {
      console.error(error);
      toast.error("Failed to export batch");
    }
  };

  // NO-MORE-NEEDED API START
  const handleNoMoreNeededApi = (batch: Batch) => {
    setBatchGuidId(batch?.batchGuid);
    setDeleteDialogOpen(true);
  };

  const confirmNoMoreNeeded = async () => {
    if (!batchGuidId) return;
    try {
      setIsCreatingBatch(true);
      setLoading(true);
      await NoMoreNeededBatchDocuments(batchGuidId);
      toast.success("Batch marked as 'No More Needed' successfully.");
      setDeleteDialogOpen(false);
      setBatchGuidId(null);
    } catch (error) {
      toast.error("Failed");
    } finally {
      setLoading(false);
      setIsCreatingBatch(false);
    }
  };

  const cancelNoMoreNeeded = () => {
    setDeleteDialogOpen(false);
    setBatchGuidId(null);
  };
  // NO-MORE-NEEDED API END

  const handleConfirmUpload = async () => {
    if (!uploadingBatchId || batchFiles.length === 0) {
      toast.error("Please select files");
      return;
    }
    try {
      setIsUploading(true);
      const response = await uploadBatchCertificates(
        uploadingBatchId,
        batchFiles,
      );
      toast.success(response || "Certificates uploaded successfully");
      setIsCreatingBatch(!isCreatingBatch);
      setShowUploadDialog(false);
      setUploadingBatchId(null);
      setBatchFiles([]);
    } catch (error) {
      const message = axios.isAxiosError<{ message?: unknown }>(error)
        ? error.response?.data?.message
        : undefined;
      toast.error(
        typeof message === "string" && message.trim()
          ? message
          : "Failed to upload certificates",
      );
    } finally {
      setIsUploading(false);
    }
  };

  const handleConfirmApproval = () => {
    if (!uploadingBatchId) return;

    const selectedIds = batchSelections[uploadingBatchId] || [];

    // Update certificate status to 'found' for approved applicants
    setBatches(
      batches.map((b) => {
        if (b.id === uploadingBatchId) {
          const updatedApplicants = b.applicants.map((app) =>
            selectedIds.includes(String(app.id)) && app.status === "uploaded"
              ? {
                  ...app,
                  certificateStatus: "found" as const,
                  certificateFile: `${app.itsNumber}_${app.firstName} _visa.pdf`,
                }
              : app,
          );
          return {
            ...b,
            applicants: updatedApplicants,
          };
        }
        return b;
      }),
    );

    // Clear selection
    setBatchSelections({ ...batchSelections, [uploadingBatchId]: [] });

    toast.success(`${selectedIds.length} applicant(s) approved successfully`);
    setShowReviewApproveDialog(false);
    setUploadingBatchId(null);
  };

  const handleCertificateUpload = (applicantId: string, file: File) => {
    if (!uploadingBatchId) return;

    // Validate file size (max 3MB)
    if (file.size > 3 * 1024 * 1024) {
      toast.error("File size should not be more than 3 MB");
      return;
    }

    // Validate file type
    const validTypes = [".pdf", ".jpg", ".jpeg", ".png"];
    const fileExtension = "." + file.name.split(".").pop()?.toLowerCase();
    if (!validTypes.includes(fileExtension)) {
      toast.error("Invalid file type. Please upload PDF, JPG, JPEG, or PNG");
      return;
    }

    // Update applicant's certificate status
    setBatches(
      batches.map((b) => {
        if (b.id === uploadingBatchId) {
          const updatedApplicants = b.applicants.map((app) =>
            String(app.id) === applicantId
              ? {
                  ...app,
                  certificateStatus: "found" as const,
                  certificateFile: file.name,
                }
              : app,
          );
          return {
            ...b,
            applicants: updatedApplicants,
          };
        }
        return b;
      }),
    );

    toast.success("Certificate uploaded successfully");
    setUploadingApplicantId(null);
  };

  const getStatusBadge = (status: string) => {
    const normalizedStatus = status?.toLowerCase();
    switch (normalizedStatus) {
      case "system_approved":
      case "documents_approved":
        return (
          <Badge
            variant="outline"
            className="bg-green-50 text-green-700 border-green-200 text-xs"
          >
            <CheckCircle2 className="w-3 h-3 mr-1" />
            System Approved
          </Badge>
        );
      case "submitted":
        return (
          <Badge
            variant="outline"
            className="bg-green-50 text-green-700 border-green-200 text-xs"
          >
            <CheckCircle2 className="w-3 h-3 mr-1" />
            Submitted
          </Badge>
        );
      case "in_progress":
        return (
          <Badge
            variant="outline"
            className="bg-yellow-50 text-yellow-700 border-yellow-200 text-xs"
          >
            <Clock className="w-3 h-3 mr-1" />
            In Progress
          </Badge>
        );
      case "review_needed":
        return (
          <Badge
            variant="outline"
            className="bg-orange-50 text-orange-700 border-orange-200 text-xs"
          >
            <AlertCircle className="w-3 h-3 mr-1" />
            Review Needed
          </Badge>
        );
      case "request_more_info":
        return (
          <Badge
            variant="outline"
            className="bg-orange-50 text-orange-700 border-orange-200 text-xs"
          >
            <AlertCircle className="w-3 h-3 mr-1" />
            Request More Info
          </Badge>
        );
      case "do_not_process":
        return (
          <Badge
            variant="outline"
            className="bg-red-50 text-red-700 border-red-200 text-xs"
          >
            <XCircle className="w-3 h-3 mr-1" />
            Do Not Process
          </Badge>
        );
      case "refunded":
        return (
          <Badge
            variant="outline"
            className="bg-gray-50 text-gray-700 border-gray-300 text-xs"
          >
            <CheckCircle2 className="w-3 h-3 mr-1" />
            Refunded
          </Badge>
        );
      case "batch_added":
      case "1":
        return (
          <Badge
            variant="outline"
            className="bg-blue-50 text-blue-700 border-blue-200 text-xs"
          >
            <Package className="w-3 h-3 mr-1" />
            Batch Added
          </Badge>
        );
      case "created":
        return (
          <Badge
            variant="outline"
            className="bg-blue-50 text-blue-700 border-blue-200 text-xs"
          >
            <Package className="w-3 h-3 mr-1" />
            Created
          </Badge>
        );
      case "exported":
      case "2":
        return (
          <Badge
            variant="outline"
            className="bg-purple-50 text-purple-700 border-purple-200 text-xs"
          >
            <FileDown className="w-3 h-3 mr-1" />
            Exported
          </Badge>
        );
      case "uploaded":
      case "3":
        return (
          <Badge
            variant="outline"
            className="bg-cyan-50 text-cyan-700 border-cyan-200 text-xs"
          >
            <Upload className="w-3 h-3 mr-1" />
            Uploaded
          </Badge>
        );
      case "4":
        return (
          <Badge
            variant="outline"
            className="bg-cyan-50 text-cyan-700 border-cyan-200 text-xs"
          >
            <Upload className="w-3 h-3 mr-1" />
            Partially Uploaded
          </Badge>
        );
      case "sent":
        return (
          <Badge
            variant="outline"
            className="bg-emerald-50 text-emerald-700 border-emerald-200 text-xs"
          >
            <Send className="w-3 h-3 mr-1" />
            Sent
          </Badge>
        );
      case "missing":
      case "applicant_processing":
        return (
          <Badge
            variant="outline"
            className="bg-orange-50 text-orange-600 border-orange-200 text-xs"
          >
            <CircleAlert className="w-3 h-3 mr-1" />
            Missing
          </Badge>
        );
      case "found":
        return (
          <Badge
            variant="outline"
            className="bg-green-50 text-green-600 border-green-200 text-xs"
          >
            <Send className="w-3 h-3 mr-1" />
            Attached
          </Badge>
        );
      case "no_more_needed":
        return (
          <Badge
            variant="outline"
            className="bg-orange-50 text-orange-600 border-orange-200 text-xs"
          >
            {/* <Send className="w-3 h-3 mr-1" /> */}
            No More Needed
          </Badge>
        );
      case "on_hold":
        return (
          <Badge
            variant="outline"
            className="bg-red-50 text-red-500 border-red-200 text-xs"
          >
            <AlertCircle className="w-3 h-3 mr-1" />
            On Hold
          </Badge>
        );
      default:
        return null;
    }
  };

  const handleShowActivityLogs = async (visaApplicantId: number) => {
    try {
      setStatusHistoryLoader(true);
      const data = await getStatusHistory(visaApplicantId);
      if (data?.length > 0) {
        setSelectedApplicantForLogs(data);
        setShowActivityLogs(true);
      }
    } catch (error) {
      console.error("Error fetching status history:", error);
    } finally {
      setStatusHistoryLoader(false);
    }
  };

  const getEffectiveStatus = (applicant: DraftVisaItem) => {
    const status = applicant.currentStatusCode?.toLowerCase();

    if (!applicant.batchId && status === "submitted") {
      return "in_progress";
    }

    return status;
  };

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedApplicants = useMemo(() => {
    if (!sortColumn) return visaRequestedList;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [...visaRequestedList].sort((a: any, b: any) => {
      if (sortColumn === "age" || sortColumn === "visaFee") {
        const aValue = Number(a[sortColumn] ?? 0);
        const bValue = Number(b[sortColumn] ?? 0);
        const comparison = aValue - bValue;

        return sortDirection === "asc" ? comparison : -comparison;
      }

      const aValue = String(a[sortColumn] ?? "");
      const bValue = String(b[sortColumn] ?? "");

      if (aValue == null) return 1;
      if (bValue == null) return -1;

      const comparison = String(aValue).localeCompare(
        String(bValue),
        undefined,
        { numeric: true, sensitivity: "base" },
      );

      return sortDirection === "asc" ? comparison : -comparison;
    });
  }, [visaRequestedList, sortColumn, sortDirection]);

  // UI STARTED
  return (
    <div className="space-y-4 md:space-y-6 px-2 md:px-0">
      {loading && <FullScreenLoading />}
      {/* Header */}
      <div className="flex flex-col gap-3 md:gap-2">
        {/* Stats Dashboard */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Card
            className="bg-gradient-to-br from-white to-sky-50 border-sky-200 shadow-lg hover:shadow-xl transition-shadow"
            style={{ marginTop: "0px" }}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <Users className="w-5 h-5 text-sky-500" />
                <div className="text-2xl text-gray-900">
                  {dashboardSummary?.systemApplicants ?? 0}
                </div>
              </div>
              <p className="text-xs text-gray-600">Applicants</p>
            </CardContent>
          </Card>

          <Card
            className="bg-gradient-to-br from-white to-blue-50 border-blue-200 shadow-lg hover:shadow-xl transition-shadow"
            style={{ marginTop: "0px" }}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <Package className="w-5 h-5 text-blue-500" />
                <div className="text-2xl text-gray-900">
                  {dashboardSummary?.totalBatches ?? 0}
                </div>
              </div>
              <p className="text-xs text-gray-600">Total Batches</p>
            </CardContent>
          </Card>

          <Card
            className="bg-gradient-to-br from-white to-purple-50 border-purple-200 shadow-lg hover:shadow-xl transition-shadow"
            style={{ marginTop: "0px" }}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <FileDown className="w-5 h-5 text-purple-500" />
                <div className="text-2xl text-gray-900">
                  {dashboardSummary?.exportedApplicants ?? 0}
                </div>
              </div>
              <p className="text-xs text-gray-600">Exported Applicants</p>
            </CardContent>
          </Card>

          <Card
            className="bg-gradient-to-br from-white to-orange-50 border-orange-200 shadow-lg hover:shadow-xl transition-shadow"
            style={{ marginTop: "0px" }}
          >
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-2">
                <PauseCircle className="w-5 h-5 text-orange-500" />
                <div className="text-2xl text-gray-900">
                  {dashboardSummary?.applicantsOnHold ?? 0}
                </div>
              </div>
              <p className="text-xs text-gray-600">Applicants on Hold</p>
            </CardContent>
          </Card>
        </div>
      </div>

      {/* Search Bar */}
      <div className="flex gap-2" style={{ marginTop: "10px" }}>
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
          <Input
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setFilterFields((prev) => ({
                ...prev,
                pageNo: 1, // Reset to first page on search
              }));
            }}
            className="pl-9 md:pl-10 border-gray-300 rounded-lg h-9 md:h-10 text-sm"
          />
          {searchTerm && (
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setSearchTerm("")}
              className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 md:w-5 md:h-5 text-gray-500"
            >
              <X className="w-4 h-4" />
            </Button>
          )}
        </div>
        {/* <Button
          variant={showFilters ? "default" : "outline"}
          size="icon"
          onClick={() => setShowFilters(!showFilters)}
          style={showFilters ? { background: "#5B9BD5" } : {}}
          className={
            showFilters
              ? "text-white"
              : "border-[#5B9BD5] text-[#5B9BD5] hover:bg-sky-50"
          }
          title="Toggle Advanced Filters"
        >
          <Filter className="w-5 h-5" />
        </Button> */}
      </div>

      {/* Advanced Filters Section */}
      {showFilters && (
        <Card
          className="border-[#5B9BD5]/30 bg-gradient-to-br from-sky-50/50 to-blue-50/50 mb-4"
          style={{ gap: "0px" }}
        >
          <CardHeader className="pb-3">
            <div className="flex items-center justify-between">
              <div>
                <CardTitle
                  style={{ color: "#5B9BD5" }}
                  className="flex items-center gap-2 text-lg"
                >
                  <Filter className="w-5 h-5" />
                  Advanced Filters
                </CardTitle>
                <CardDescription className="mt-1">
                  Filter completed applications by multiple criteria
                </CardDescription>
              </div>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowFilters(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <X className="w-4 h-4" />
              </Button>
            </div>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              {/* Applicant Name Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-applicant-name" className="text-sm">
                  Applicant Name
                </Label>
                <Input
                  id="filter-applicant-name"
                  placeholder="Search by name..."
                  value={filterFields.applicantName}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      applicantName: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* ITS Number Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-its" className="text-sm">
                  ITS Number
                </Label>
                <Input
                  id="filter-its"
                  placeholder="Search by ITS..."
                  value={filterFields.itsNo}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      itsNo: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Passport Number Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-passport" className="text-sm">
                  Passport No.
                </Label>
                <Input
                  id="filter-passport"
                  placeholder="Search by passport..."
                  value={filterFields.passportNo}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      passportNo: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Nationality Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-nationality" className="text-sm">
                  Nationality
                </Label>
                <Input
                  id="filter-nationality"
                  placeholder="Search by nationality..."
                  value={filterFields.nationality}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      nationality: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Partner Name Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-partner" className="text-sm">
                  Partner Name
                </Label>
                <Input
                  id="filter-partner"
                  placeholder="Search by partner..."
                  value={filterFields.partnerName}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      partnerName: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Office Name Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-office" className="text-sm">
                  Office Name
                </Label>
                <Input
                  id="filter-office"
                  placeholder="Search by office..."
                  value={filterFields.officeName}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      officeName: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Visa ID Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-visa-id" className="text-sm">
                  Visa ID
                </Label>
                <Input
                  id="filter-visa-id"
                  placeholder="Search by Visa ID..."
                  value={filterFields.visaId}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      visaId: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Tour Ref No Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-tour-ref" className="text-sm">
                  Tour Reference
                </Label>
                <Input
                  id="filter-tour-ref"
                  placeholder="Search by tour ref..."
                  value={filterFields.tourRefNo}
                  onChange={(e) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      tourRefNo: e.target.value,
                      pageNo: 1,
                    }))
                  }
                  className="h-9 text-sm"
                />
              </div>

              {/* Visa Required Filter */}
              <div className="space-y-2">
                <Label htmlFor="filter-visa-required" className="text-sm">
                  Visa Required
                </Label>
                <Select
                  value={filterFields.visaRequired || "all"}
                  onValueChange={(value) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      visaRequired: value === "all" ? "" : value,
                      pageNo: 1,
                    }))
                  }
                >
                  <SelectTrigger
                    id="filter-visa-required"
                    className="bg-input-background h-9 text-sm"
                  >
                    <SelectValue placeholder="Select visa requirement..." />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="true">Yes</SelectItem>
                    <SelectItem value="false">No</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>

            {/* Active Filters Summary & Clear Button */}
            {(filterFields.applicantName ||
              filterFields.itsNo ||
              filterFields.passportNo ||
              filterFields.nationality ||
              filterFields.visaRequired) && (
              <div className="flex items-center justify-between gap-3 p-3 bg-white border border-[#5B9BD5]/30 rounded-lg mt-4">
                <div className="flex-1">
                  <p className="text-sm font-medium text-[#5B9BD5] mb-2">
                    Active Filters:
                  </p>
                  <div className="flex flex-wrap gap-1.5">
                    {/* {filterFields.applicationNo && (
                            <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs">
                              Application: {filterFields.applicationNo}
                            </Badge>
                          )} */}
                    {filterFields.applicantName && (
                      <Badge
                        variant="outline"
                        className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                      >
                        Name: {filterFields.applicantName}
                      </Badge>
                    )}
                    {filterFields.itsNo && (
                      <Badge
                        variant="outline"
                        className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                      >
                        ITS: {filterFields.itsNo}
                      </Badge>
                    )}
                    {filterFields.passportNo && (
                      <Badge
                        variant="outline"
                        className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                      >
                        Passport: {filterFields.passportNo}
                      </Badge>
                    )}
                    {filterFields.nationality && (
                      <Badge
                        variant="outline"
                        className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                      >
                        Nationality: {filterFields.nationality}
                      </Badge>
                    )}
                    {/* {filterFields.status && (
                            <Badge variant="outline" className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs">
                              Status: {filterFields.status.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                            </Badge>
                          )} */}
                    {filterFields.visaRequired && (
                      <Badge
                        variant="outline"
                        className="border-[#5B9BD5]/30 text-[#5B9BD5] text-xs"
                      >
                        Visa Required:{" "}
                        {filterFields.visaRequired === "true" ? "Yes" : "No"}
                      </Badge>
                    )}
                  </div>
                </div>
                {/* <div className="flex justify-end gap-2 pt-2"> */}
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() =>
                    setFilterFields({
                      applicantName: "",
                      itsNo: "",
                      passportNo: "",
                      nationality: "",
                      partnerName: "",
                      officeName: "",
                      visaId: "",
                      tourRefNo: "",
                      visaRequired: "",
                      pageNo: 1,
                      pageSize: 20,
                      status: "new",
                    })
                  }
                  className="text-red-600 border-red-300 hover:bg-red-50 flex-shrink-0"
                >
                  Clear All
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Tabs */}
      <div
        className="flex gap-2 border-b-2 border-gray-200"
        style={{ marginTop: "0px" }}
      >
        <button
          onClick={() => setActiveTab("system")}
          className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors -mb-0.5 ${
            activeTab === "system"
              ? "border-[#5B9BD5] text-[#5B9BD5]"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          <Users className="w-4 h-4 md:w-4 md:h-4 inline-block mr-1 md:mr-2" />
          <span className="hidden sm:inline">Applicants</span>
          <span className="sm:hidden">System</span> ({totalVisaReqCount})
        </button>
        <button
          onClick={() => setActiveTab("batch")}
          className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors -mb-0.5 ${
            activeTab === "batch"
              ? "border-[#5B9BD5] text-[#5B9BD5]"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`}
        >
          <Package className="w-4 h-4 inline-block mr-2" />
          <span className="hidden sm:inline">Batches</span>
          <span className="sm:hidden">Batch</span> (
          {totalBatchCount ? totalBatchCount : batchFilterCounts.totalCount})
        </button>
      </div>

      {/* System Applicant List Tab */}
      {activeTab === "system" && (
        <Card className="bg-white border-2 border-sky-200 shadow-lg rounded-xl">
          <CardContent className="p-3 md:p-6">
            {/* Action Bar */}
            {selectedApplicants.length > 0 && (
              <div className="mb-3 md:mb-4 p-3 md:p-4 bg-sky-50 border-2 border-sky-200 rounded-lg">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                  <div className="flex items-center gap-2">
                    <CheckCircle
                      className="w-4 h-4 md:w-5 md:h-5"
                      style={{ color: "#5B9BD5" }}
                    />
                    <span className="text-xs md:text-sm font-medium text-gray-900">
                      {selectedApplicants.length} selected
                    </span>
                  </div>
                  <Button
                    onClick={() => setShowBatchDialog(true)}
                    style={{ backgroundColor: "#5B9BD5" }}
                    className="text-white hover:opacity-90 text-xs md:text-sm w-full md:w-auto"
                  >
                    <Package className="w-3 h-3 md:w-4 md:h-4 mr-2" />
                    Create Batch
                  </Button>
                </div>
              </div>
            )}

            {/* Table */}
            {visaRequestedList.length === 0 ? (
              <div className="text-center py-12 text-red-400">
                <FolderOpen className="w-12 h-12 md:w-16 md:h-16 text-red-400 mx-auto mb-2" />
                <p className="text-red-400 text-sm font-semibold md:text-base">
                  No documents approved applicants found
                </p>
              </div>
            ) : (
              <>
                {/* Desktop Table View */}
                <div className="bg-white hidden md:block overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-[#5B9BD5]/10">
                      <tr>
                        <th className="text-center p-3 text-xs text-gray-900 w-12">
                          <Checkbox
                            checked={
                              selectableApplicantIds.length > 0 &&
                              selectableApplicantIds.every((id) => selectedApplicants.includes(id))
                            }
                            disabled={selectableApplicantIds.length === 0}
                            onCheckedChange={handleSelectAll}
                            aria-label="Select all"
                          />
                        </th>
                        <th
                          className="px-4 py-3 text-xs cursor-pointer select-none hover:bg-sky-100/50"
                          onClick={() => handleSort("firstName")}
                        >
                          <div className="flex items-center gap-1">
                            Applicant Details
                            {sortColumn === "firstName" ? (
                              sortDirection === "asc" ? (
                                <ArrowUp className="w-3 h-3" />
                              ) : (
                                <ArrowDown className="w-3 h-3" />
                              )
                            ) : (
                              <ArrowUpDown className="w-3 h-3 opacity-30" />
                            )}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-xs cursor-pointer select-none hover:bg-sky-100/50"
                          onClick={() => handleSort("passportNo")}
                        >
                          <div className="flex items-center gap-1">
                            Passport No.
                            {sortColumn === "passportNo" ? (
                              sortDirection === "asc" ? (
                                <ArrowUp className="w-3 h-3" />
                              ) : (
                                <ArrowDown className="w-3 h-3" />
                              )
                            ) : (
                              <ArrowUpDown className="w-3 h-3 opacity-30" />
                            )}
                          </div>
                        </th>

                        <th
                          className="px-4 py-3 text-xs cursor-pointer select-none hover:bg-sky-100/50"
                          onClick={() => handleSort("passportNo")}
                        >
                          <div className="flex items-center gap-1">
                            Passport Nationality
                            {sortColumn === "passportNationality" ? (
                              sortDirection === "asc" ? (
                                <ArrowUp className="w-3 h-3" />
                              ) : (
                                <ArrowDown className="w-3 h-3" />
                              )
                            ) : (
                              <ArrowUpDown className="w-3 h-3 opacity-30" />
                            )}
                          </div>
                        </th>

                        <th
                          className="text-center cursor-pointer select-none p-3 text-xs text-gray-900 hover:bg-sky-100/50"
                          onClick={() => handleSort("age")}
                        >
                          <div className="flex items-center gap-1">
                            Age
                            {sortColumn === "age" ? (
                              sortDirection === "asc" ? (
                                <ArrowUp className="w-3 h-3" />
                              ) : (
                                <ArrowDown className="w-3 h-3" />
                              )
                            ) : (
                              <ArrowUpDown className="w-3 h-3 opacity-30" />
                            )}
                          </div>
                        </th>

                        <th
                          className="text-center cursor-pointer select-none p-3 text-xs text-gray-900 hover:bg-sky-100/50"
                          onClick={() => handleSort("visaFee")}
                        >
                          <div className="flex items-center justify-center gap-1">
                            Visa Fee
                            {sortColumn === "visaFee" ? (
                              sortDirection === "asc" ? (
                                <ArrowUp className="w-3 h-3" />
                              ) : (
                                <ArrowDown className="w-3 h-3" />
                              )
                            ) : (
                              <ArrowUpDown className="w-3 h-3 opacity-30" />
                            )}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-xs cursor-pointer select-none hover:bg-sky-100/50"
                          onClick={() => handleSort("toOfficeName")}
                        >
                          <div className="flex items-center gap-1">
                            Partner / Office
                            {sortColumn === "toOfficeName" ? (
                              sortDirection === "asc" ? (
                                <ArrowUp className="w-3 h-3" />
                              ) : (
                                <ArrowDown className="w-3 h-3" />
                              )
                            ) : (
                              <ArrowUpDown className="w-3 h-3 opacity-30" />
                            )}
                          </div>
                        </th>
                        <th
                          className="px-4 py-3 text-xs cursor-pointer select-none hover:bg-sky-100/50"
                          onClick={() => handleSort("applicationNumber")}
                        >
                          <div className="flex items-center gap-1">
                            Tour Info
                            {sortColumn === "applicationNumber" ? (
                              sortDirection === "asc" ? (
                                <ArrowUp className="w-3 h-3" />
                              ) : (
                                <ArrowDown className="w-3 h-3" />
                              )
                            ) : (
                              <ArrowUpDown className="w-3 h-3 opacity-30" />
                            )}
                          </div>
                        </th>
                        <th className="text-center p-3 text-xs text-gray-900">
                          Status
                        </th>
                        <th className="text-center p-3 text-xs text-gray-900">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {visaRequestedList &&
                        sortedApplicants?.map((applicant, index) => (
                          <tr
                            key={applicant.visaApplicationId}
                            className={`border - b border - gray - 100 hover: bg - [#5B9BD5] / 5 ${
                              selectedApplicants.includes(
                                applicant.visaApplicationId,
                              )
                                ? "bg-blue-50"
                                : ""
                            } `}
                          >
                            {/* Checkbox */}
                            <td className="p-3 text-center">
                              <Checkbox
                                checked={selectedApplicants.includes(
                                  Number(applicant.visaApplicationId),
                                )}
                                onCheckedChange={() =>
                                  handleSelectApplicant(
                                    Number(applicant.visaApplicationId),
                                  )
                                }
                                disabled={applicant.currentStatusCode?.toLowerCase() === "on_hold"}
                                className="disabled:cursor-not-allowed"
                                aria-label={`Select ${applicant.firstName} ${applicant.lastName} `}
                              />
                            </td>

                            {/* Applicant Details */}
                            <td className="p-3">
                              <div className="flex items-center gap-2">
                                <div className="flex-1">
                                  <p className="text-xs text-gray-900">
                                    {applicant.title} {applicant.firstName}{" "}
                                    {applicant.middleName} {applicant.lastName}
                                  </p>
                                  <p className="text-xs text-gray-500 mt-0.5">
                                    {/* {applicant.itsNumber || applicant.loginId} */}
                                    {applicant.itsNo || "N/A"}
                                  </p>
                                </div>
                                {/* Admin Review Indicator */}
                                {applicant.hasNameDiscrepancy &&
                                  applicant.currentStatusCode?.toLowerCase() !==
                                    "submitted" && (
                                    <div
                                      className="flex-shrink-0"
                                      title="⚠️ Name discrepancy detected"
                                    >
                                      <div className="relative">
                                        <div className="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center animate-pulse">
                                          <AlertCircle className="w-4 h-4 text-orange-600" />
                                        </div>
                                        <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full border-2 border-white" />
                                      </div>
                                    </div>
                                  )}
                              </div>
                            </td>

                            {/* Passport No */}
                            <td className="p-3">
                              <p className="text-xs text-gray-900">
                                {applicant.passportNo || "-"}
                              </p>
                            </td>

                            <td className="p-3 text-center">
                              <p className="text-xs text-gray-900">
                                {applicant.passportNationality ?? "-"}
                              </p>
                            </td>

                            {/* age */}
                            <td className="p-3">
                              <p className="text-xs text-gray-900">
                                {applicant.age || "-"}
                              </p>
                            </td>

                            {/* Visa Fee */}
                            <td className="p-3 text-center">
                              {applicant.visaRequired ? (
                                <div className="flex flex-col items-center gap-1">
                                  <span className="text-xs text-gray-900">
                                    ${applicant.visaFee || 0}
                                  </span>
                                </div>
                              ) : (
                                <Badge
                                  variant="outline"
                                  className="bg-gray-50 text-gray-600 border-gray-200 text-xs"
                                >
                                  <XCircle className="w-3 h-3 mr-1" />
                                  No
                                </Badge>
                              )}
                            </td>

                            {/* Partner / Office */}
                            <td className="p-3">
                              {/* <p className="text-xs text-gray-900">{applicant.partnerOffice}</p> */}
                              <p className="text-xs text-gray-900">
                                {applicant.toOfficeName || ""}
                              </p>
                            </td>

                            {/* Tour Info */}
                            <td className="p-3">
                              <div>
                                <p
                                  className="text-xs"
                                  style={{ color: "#5B9BD5" }}
                                >
                                  {applicant.applicationNumber}
                                </p>
                                <p className="text-xs text-gray-500 mt-0.5">
                                  {applicant.batchNumber || ""}
                                  {/* {"TOUR-2025-045-ST"} */}
                                </p>
                                {/* {applicant.tourOperatorId ? (
                              <p className="text-xs text-gray-500 mt-0.5">
                                {applicant.tourOperatorId}
                              </p>
                              ) : (
                                <p className="text-xs text-gray-500 mt-0.5">No tour</p>
                              )} */}
                              </div>
                            </td>

                            {/* Status */}
                            <td className="p-3 text-center">
                              <div className="flex flex-col items-center gap-1">
                                {getStatusBadge(getEffectiveStatus(applicant))}
                              </div>
                            </td>
                            {/* Actions */}
                            <td className="p-3">
                              <div className="flex items-center justify-center gap-1">
                                {applicant.certificateFilePath !== null && (
                                  <div className="flex items-center justify-center gap-1">
                                    <button
                                      className="flex items-center justify-center  h-7 w-7 p-0 hover:bg-blue-50"
                                      onClick={() => {
                                        const fullUrl = getFileViewUrl(
                                          applicant?.certificateFilePath,
                                        );
                                        window.open(fullUrl, "_blank");
                                      }}
                                      title={"view document"}
                                    >
                                      <FileUser className="w-4 h-4 cursor-pointer text-blue-600" />
                                    </button>
                                  </div>
                                )}

                                <Button
                                  size="sm"
                                  variant="ghost"
                                  onClick={() =>
                                    navigate(
                                      `/visa-muwafiqa/visa-document-required/${applicant.visaApplicationId}`,
                                    )
                                  }
                                  className="h-7 w-7 p-0 hover:bg-blue-50"
                                >
                                  <Eye className="w-3.5 h-3.5 text-blue-600" />
                                </Button>
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  onClick={() =>
                                    handleShowActivityLogs(
                                      applicant?.visaApplicationId,
                                    )
                                  }
                                  className="h-7 w-7 p-0 hover:bg-blue-50"
                                  style={{ color: "#9333ea" }}
                                >
                                  <Activity className="w-3.5 h-3.5" />
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* Mobile Card View */}
                <div className="md:hidden space-y-3">
                  {visaRequestedList.map((applicant) => (
                    <Card
                      key={applicant.visaApplicationId}
                      className={`border - 2 ${selectedApplicants.includes(applicant.visaApplicationId) ? "border-[#5B9BD5] bg-blue-50" : "border-gray-200"} `}
                    >
                      <CardContent className="p-3">
                        <div className="flex items-start gap-3">
                          {/* Checkbox */}
                          <div className="pt-1">
                            <Checkbox
                              checked={selectedApplicants.includes(
                                applicant.visaApplicationId,
                              )}
                              onCheckedChange={() =>
                                handleSelectApplicant(
                                  applicant.visaApplicationId,
                                )
                              }
                              disabled={applicant.currentStatusCode?.toLowerCase() === "on_hold"}
                              className="disabled:cursor-not-allowed"
                              aria-label={`Select ${applicant.firstName} ${applicant.lastName} `}
                            />
                          </div>

                          {/* Content */}
                          <div className="flex-1 min-w-0">
                            {/* Name & ITS */}
                            <div className="flex items-start justify-between gap-2 mb-2">
                              <div className="flex-1 min-w-0">
                                <h3 className="text-sm font-semibold text-gray-900">
                                  {applicant.title} {applicant.firstName}{" "}
                                  {applicant.middleName} {applicant.lastName}
                                </h3>
                                <p className="text-xs text-gray-500 mt-0.5">
                                  {/* ITS: {applicant.itsNo || applicant.loginId} */}
                                  ITS: {applicant.itsNo || "N/A"}
                                </p>
                              </div>
                              {applicant.hasNameDiscrepancy &&
                                applicant.currentStatusCode?.toLowerCase() !==
                                  "submitted" && (
                                  <div
                                    className="flex-shrink-0"
                                    title="⚠️ Name discrepancy detected"
                                  >
                                    <div className="relative">
                                      <div className="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center animate-pulse">
                                        <AlertCircle className="w-4 h-4 text-orange-600" />
                                      </div>
                                      <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full border-2 border-white" />
                                    </div>
                                  </div>
                                )}
                            </div>

                            {/* Application & Passport */}
                            <div className="grid grid-cols-2 gap-2 mb-2 text-xs">
                              <div>
                                <p className="text-gray-500">Application</p>
                                <p
                                  className="font-medium"
                                  style={{ color: "#5B9BD5" }}
                                >
                                  {applicant.applicationNumber}
                                </p>
                              </div>
                              <div>
                                <p className="text-gray-500">Passport</p>
                                <p className="font-medium text-gray-900">
                                  {applicant.passportNo || "-"}
                                </p>
                              </div>
                            </div>

                            {/* Visa Fee & Nationality */}
                            <div className="grid grid-cols-2 gap-2 mb-2 text-xs">
                              <div>
                                <p className="text-gray-500">Visa Fee</p>
                                {applicant.visaRequired ? (
                                  // <p className="font-medium text-gray-900">${applicant.visaCost}</p>
                                  <p className="font-medium text-gray-900">
                                    ${applicant.visaFee || 0}
                                  </p>
                                ) : (
                                  <Badge
                                    variant="outline"
                                    className="bg-gray-50 text-gray-600 border-gray-200 text-xs px-2 py-0"
                                  >
                                    No
                                  </Badge>
                                )}
                              </div>
                              <div>
                                <p className="text-gray-500">Nationality</p>
                                <p className="font-medium text-gray-900">
                                  {/* {applicant.nationality} */}
                                  {applicant.passportNationality}
                                </p>
                              </div>
                            </div>

                            {/* Partner Office */}
                            <div className="mb-2 text-xs">
                              <p className="text-gray-500">Partner Office</p>
                              {/* <p className="font-medium text-gray-900 text-sm">{applicant.partnerOffice}</p> */}
                              <p className="font-medium text-gray-900 text-sm">
                                {/* {"Al-Khidmat Tours / Surat Branch-ST"} */}
                                {applicant.toOfficeName || "N/A"}
                              </p>
                            </div>

                            {/* Status & Action */}
                            <div className="flex items-center justify-between pt-2 border-t">
                              {getStatusBadge(getEffectiveStatus(applicant))}

                              {applicant.certificateFilePath !== null && (
                                <div className="flex items-center justify-center gap-1">
                                  <button
                                    className="flex items-center justify-center  h-7 w-7 p-0 hover:bg-blue-50"
                                    onClick={() => {
                                      const fullUrl = getFileViewUrl(
                                        applicant?.certificateFilePath,
                                      );
                                      window.open(fullUrl, "_blank");
                                    }}
                                    title={"view document"}
                                  >
                                    <FileUser className="w-4 h-4 cursor-pointer text-blue-600" />
                                  </button>
                                </div>
                              )}

                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() =>
                                  navigate(
                                    `/visa-muwafiqa/visa-document-required/${applicant.visaApplicationId}`,
                                  )
                                }
                                className="h-8 px-3 hover:bg-blue-50"
                              >
                                <Eye className="w-3.5 h-3.5 text-blue-600 mr-1" />
                              </Button>

                              <Button
                                size="sm"
                                variant="ghost"
                                onClick={() =>
                                  handleShowActivityLogs(
                                    applicant?.visaApplicationId,
                                  )
                                }
                                className="h-7 w-7 p-0 hover:bg-blue-50"
                                style={{ color: "#9333ea" }}
                              >
                                <Activity className="w-3.5 h-3.5" />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  ))}
                </div>

                {/* PAGINATION COMPONENT */}
                <Pagination
                  totalItems={totalVisaReqCount}
                  itemsPerPage={filterFields.pageSize}
                  currentPage={filterFields.pageNo}
                  onPageChange={(page) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      pageNo: page, // convert back to 0-based
                    }))
                  }
                  onPageSizeChange={(size) =>
                    setFilterFields((prev) => ({
                      ...prev,
                      pageSize: size,
                      pageNo: 1, // reset page
                    }))
                  }
                  label=""
                />
              </>
            )}
          </CardContent>
        </Card>
      )}

      {/* Batch List Tab */}
      {activeTab === "batch" && (
        <Card className="border-2 border-sky-200 shadow-lg rounded-xl">
          <CardHeader className="p-4 bg-white border-b bg-gradient-to-r from-sky-50 to-blue-50">
            <div className="flex flex-col gap-4">
              <Tabs
                value={BatchactiveTab}
                onValueChange={(v) => {
                  if (
                    v === "*" ||
                    v === "new" ||
                    v === "pending" ||
                    v === "approved"
                  ) {
                    setBatchActiveTab(v);
                    setFilterFields((prev) => ({
                      ...prev,
                      status: v,
                      pageNo: 1,
                    }));
                  }
                }}
              >
                <TabsList
                  style={{ backgroundColor: "rgba(91, 155, 213, 0.1)" }}
                  className="rounded-full w-full grid grid-cols-3"
                >
                  <TabsTrigger
                    value="new"
                    className="p-2 rounded-full data-[state=active]:bg-white data-[state=active]:text-gray-900 text-xs font-semibold sm:text-sm"
                  >
                    <span className="hidden sm:inline">New</span>
                    <span className="sm:hidden">New</span>
                    <span className="ml-1">
                      ({batchFilterCounts.newCount ?? 0})
                    </span>
                  </TabsTrigger>
                  <TabsTrigger
                    value="pending"
                    className="p-2 rounded-full data-[state=active]:bg-white data-[state=active]:text-gray-900 text-xs font-semibold sm:text-sm"
                  >
                    <span className="hidden sm:inline">
                      Partially-Uploaded/Pending
                    </span>
                    <span className="sm:hidden">Part/Pend</span>
                    <span className="ml-1">
                      ({batchFilterCounts.pendingCount ?? 0})
                    </span>
                  </TabsTrigger>
                  <TabsTrigger
                    value="approved"
                    className="p-2 rounded-full  data-[state=active]:bg-white data-[state=active]:text-gray-900 text-xs font-semibold sm:text-sm"
                  >
                    <span className="hidden sm:inline">Completed</span>
                    <span className="sm:hidden">Com</span>
                    <span className="ml-1">
                      ({batchFilterCounts.approvedCount ?? 0})
                    </span>
                  </TabsTrigger>
                </TabsList>
              </Tabs>
            </div>
          </CardHeader>
          <CardContent className="p-6">
            {batches?.length === 0 ? (
              <div className="text-center py-12">
                <Package className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                <p className="text-gray-500">No batches created yet</p>
              </div>
            ) : (
              <div className="space-y-3">
                {batches?.map((batch) => (
                  <Card
                    key={batch.batchId}
                    className="border-2 border-gray-200 hover:border-sky-300 transition-colors"
                  >
                    <CardContent className="p-2">
                      {/* Batch Header */}
                      <div
                        className="p-2 mt-4 cursor-pointer hover:bg-gray-50 transition-colors"
                        onClick={() => toggleBatch(batch.batchId)}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-4 flex-1">
                            <div>
                              {expandedBatches.includes(batch.batchId) ? (
                                <ChevronUp className="w-5 h-5 text-gray-400" />
                              ) : (
                                <ChevronDown className="w-5 h-5 text-gray-400" />
                              )}
                            </div>
                            <div className="flex-1">
                              <div className="flex items-center gap-3 mb-2">
                                <h3 className="font-semibold text-gray-900 text-lg">
                                  {batch?.batchNumber}
                                </h3>
                                {getStatusBadge(String(batch.status))}
                              </div>
                              <div className="flex items-center gap-6 text-sm text-gray-600">
                                <div className="flex items-center gap-1">
                                  <Users className="w-4 h-4" />
                                  <span>
                                    {batch.totalApplicants} applicants
                                  </span>
                                </div>
                                <div className="flex items-center gap-1">
                                  <Clock className="w-4 h-4" />
                                  <span>
                                    {batch?.updatedAt
                                      ? `Last Action: ${batch.updatedAt?.split("T")[0]}`
                                      : `Created: ${batch?.createdOn?.split("T")[0] ?? "-"}`}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Batch Applicants (Expanded) */}
                      {expandedBatches?.includes(batch?.batchId) && (
                        <div className="border-t-2 border-gray-200 bg-gray-50 p-4 pb-2">
                          {/* Batch Action Bar */}
                          <div className="mb-4 p-3 bg-sky-50 border-2 border-sky-200 rounded-lg">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-2">
                                <Package
                                  className="w-4 h-4"
                                  style={{ color: "#5B9BD5" }}
                                />
                                <span className="text-sm font-medium text-gray-900">
                                  Batch Actions
                                </span>
                              </div>
                              <div className="flex flex-wrap items-center gap-2">
                                {/* Export Button - Always visible */}
                                {String(batch.status) !== "3" && (
                                  <Button
                                    size="sm"
                                    onClick={() => handleNoMoreNeededApi(batch)}
                                    className="text-white text-xs bg-red-400"
                                  >
                                    No More Needed
                                  </Button>
                                )}
                                {canAdd && (
                                  <Button
                                    size="sm"
                                    onClick={() =>
                                      handleExportBatchSelected(batch)
                                    }
                                    style={{ backgroundColor: "#5B9BD5" }}
                                    className="text-white text-xs"
                                  >
                                    <FileDown className="w-3.5 h-3.5 mr-1" />
                                    Export All
                                  </Button>
                                )}

                                {/* Upload Button - Always visible */}
                                {canAdd && (
                                  <Button
                                    size="sm"
                                    onClick={() => {
                                      setUploadingBatchId(batch.batchGuid);
                                      setShowUploadDialog(true);
                                    }}
                                    style={{ backgroundColor: "#5B9BD5" }}
                                    className="text-white text-xs"
                                  >
                                    <Upload className="w-3.5 h-3.5 mr-1" />
                                    Upload Certificates
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="overflow-x-auto">
                            <table className="w-full">
                              <thead className="bg-[#5B9BD5]/10">
                                <tr>
                                  <th className="text-left p-3 text-xs text-gray-900">
                                    Applicant Details
                                  </th>
                                  <th className="text-left p-3 text-xs text-gray-900">
                                    Passport No.
                                  </th>
                                  <th className="text-center p-3 text-xs text-gray-900">
                                    Passport Nationality
                                  </th>
                                  <th className="text-center p-3 text-xs text-gray-900">
                                    Age
                                  </th>
                                  <th className="text-center p-3 text-xs text-gray-900">
                                    Visa Fee
                                  </th>
                                  <th className="text-left p-3 text-xs text-gray-900">
                                    Partner / Office
                                  </th>
                                  <th className="text-left p-3 text-xs text-gray-900">
                                    Tour Info
                                  </th>
                                  <th className="text-center p-3 text-xs text-gray-900">
                                    Certificate
                                  </th>
                                  <th className="text-center p-3 text-xs text-gray-900">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {batch?.applicants?.length === 0 && (
                                  <tr>
                                    <td colSpan={7} className="py-6">
                                      <div className="flex justify-center items-center">
                                        <NoApplicantFound />
                                      </div>
                                    </td>
                                  </tr>
                                )}
                                {batch?.applicants?.map((applicant) => (
                                  <tr
                                    key={applicant.visaApplicationId}
                                    className="border-b border-gray-200 hover:bg-white"
                                  >
                                    {/* Applicant Details */}
                                    <td className="p-3">
                                      <div className="flex items-center">
                                        <div className="flex-1">
                                          <p className="text-xs text-gray-900">
                                            {applicant.title}{" "}
                                            {applicant.firstName}{" "}
                                            {applicant.middleName}{" "}
                                            {applicant.lastName}
                                          </p>
                                          <p className="text-xs text-gray-500 mt-0.5">
                                            {/* {applicant.itsNumber || applicant.loginId} */}
                                            {applicant.itsNo || "N/A"}
                                          </p>
                                        </div>
                                        {/* Admin Review Indicator */}
                                        {applicant.hasNameDiscrepancy &&
                                          applicant.currentStatusCode?.toLowerCase() !==
                                            "submitted" && (
                                            <div
                                              className="flex-shrink-0"
                                              title="⚠️ Name discrepancy detected"
                                            >
                                              <div className="relative">
                                                <div className="w-6 h-6 rounded-full bg-orange-100 flex items-center justify-center animate-pulse">
                                                  <AlertCircle className="w-4 h-4 text-orange-600" />
                                                </div>
                                                <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-500 rounded-full border-2 border-white" />
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </td>

                                    {/* Passport No */}
                                    <td className="p-3">
                                      <p className="text-xs text-gray-900">
                                        {applicant.passportNo}
                                      </p>
                                    </td>

                                    <td className="p-3 text-center">
                                      <p className="text-xs text-gray-900">
                                        {applicant.passportNationality ?? "-"}
                                      </p>
                                    </td>

                                    {/* Age */}
                                    <td className="p-3 text-center">
                                      <p className="text-xs text-gray-900">
                                        {applicant.age ?? "-"}
                                      </p>
                                    </td>

                                    {/* Visa Fee */}
                                    <td className="p-3 text-center">
                                      {applicant?.visaRequired ? (
                                        <span className="text-xs text-gray-900">
                                          ${applicant.visaFee ?? 0}
                                        </span>
                                      ) : (
                                        <Badge
                                          variant="outline"
                                          className="bg-gray-50 text-gray-600 border-gray-200 text-xs"
                                        >
                                          <XCircle className="w-3 h-3 mr-1" />
                                          No
                                        </Badge>
                                      )}
                                    </td>

                                    {/* Partner / Office */}
                                    <td className="p-3">
                                      <p className="text-xs text-gray-900">
                                        {applicant.firstName}{" "}
                                        {applicant.middleName}{" "}
                                        {applicant.lastName} /{" "}
                                        {applicant.toOfficeName}
                                      </p>
                                    </td>

                                    {/* Tour Info */}
                                    <td className="p-3">
                                      <div>
                                        <p
                                          className="text-xs"
                                          style={{ color: "#5B9BD5" }}
                                        >
                                          {applicant.applicationNumber}
                                        </p>
                                        {applicant.tourRefNo ? (
                                          <p className="text-xs text-gray-500 mt-0.5">
                                            {applicant.tourRefNo}
                                          </p>
                                        ) : (
                                          <p className="text-xs text-gray-500 mt-0.5">
                                            No tour
                                          </p>
                                        )}
                                      </div>
                                    </td>

                                    {/* Certificate Status - Default to Missing */}
                                    <td className="p-3 text-center">
                                      <div className="flex flex-col items-center gap-1">
                                        {/* {getStatusBadge(applicant.certificateStatus ? applicant.certificateStatus : applicant.currentStatusCode)} */}
                                        {getStatusBadge(
                                          applicant?.currentStatusCode ===
                                            "NO_MORE_NEEDED"
                                            ? applicant.currentStatusCode
                                            : (applicant?.certificateStatus ??
                                                applicant.currentStatusCode),
                                        )}
                                      </div>
                                    </td>

                                    {/* Actions */}
                                    <td className="flex p-3">
                                      {applicant.certificateFilePath !==
                                        null && (
                                        <div className="flex items-center justify-center gap-1">
                                          <button
                                            className="flex items-center justify-center  h-7 w-7 p-0 hover:bg-blue-50"
                                            onClick={() => {
                                              const fullUrl = getFileViewUrl(
                                                applicant?.certificateFilePath,
                                              );
                                              window.open(fullUrl, "_blank");
                                            }}
                                            title={"view document"}
                                          >
                                            <FileUser className="w-4 h-4 cursor-pointer text-blue-600" />
                                          </button>
                                        </div>
                                      )}

                                      <div className="flex items-center justify-center gap-1">
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          onClick={() =>
                                            navigate(
                                              `/visa-muwafiqa/visa-document-required/${applicant.visaApplicationId}`,
                                            )
                                          }
                                          className="h-7 w-7 p-0 hover:bg-blue-50"
                                        >
                                          <Eye className="w-3.5 h-3.5 text-blue-600" />
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          onClick={() =>
                                            handleShowActivityLogs(
                                              applicant?.visaApplicationId,
                                            )
                                          }
                                          className="h-7 w-7 p-0 hover:bg-blue-50"
                                          style={{ color: "#9333ea" }}
                                        >
                                          <Activity className="w-3.5 h-3.5" />
                                        </Button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      )}
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      )}

      {/* Create Batch Dialog */}
      {showBatchDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <Card className="bg-white shadow-lg rounded-2xl w-[500px]">
            <CardContent className="p-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">
                Create New Batch
              </h2>
              <div className="space-y-4">
                <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4">
                  <div className="space-y-2">
                    {/* <div className="flex items-center justify-between">
                      <p className="text-sm text-gray-700">Batch Name:</p>
                      <p className="text-sm font-semibold text-gray-900">
                        GRP-{new Date().getFullYear().toString().slice(-2)}-
                        {String(batches.length + 1).padStart(6, "0")}
                      </p>
                    </div> */}
                    <div className="flex items-center justify-between">
                      <p className="text-sm text-gray-700">Total Applicants:</p>
                      <p className="text-sm font-semibold text-gray-900">
                        {selectedApplicants.length}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-3">
                  <p className="text-xs text-amber-800">
                    Batch name will be automatically generated with serial
                    number
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-end gap-3 mt-6">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowBatchDialog(false);
                    setBatchName("");
                    setBatchRemark("");
                  }}
                  className="text-gray-900 hover:bg-gray-100"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleCreateBatch}
                  disabled={isCreatingBatch}
                  style={{ backgroundColor: "#5B9BD5" }}
                  className="text-white hover:opacity-90 px-6 flex items-center"
                >
                  {isCreatingBatch ? (
                    <>
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                      Creating...
                    </>
                  ) : (
                    <>
                      <Package className="w-4 h-4 mr-2" />
                      Create Batch
                    </>
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Upload Dialog */}
      {showUploadDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <Card className="bg-white shadow-lg rounded-2xl w-[500px]">
            <CardContent className="p-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-4">
                Upload Documents
              </h2>
              <div className="space-y-4">
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center">
                  <Upload className="w-8 h-8 text-gray-400 mx-auto mb-3" />
                  <Input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    // accept=".pdf,.jpg,.jpeg,.png"
                    accept=".pdf"
                    className="hidden"
                    onChange={(e) => {
                      const files = Array.from(e.target.files || []);
                      setBatchFiles(files);
                    }}
                  />
                  <p className="text-sm text-gray-600 mt-2 mb-2">
                    {batchFiles.length > 0
                      ? `${batchFiles.length} file(s) selected`
                      : "No files selected"}
                  </p>
                  <div className="flex justify-center">
                    <Label htmlFor="batch-upload">
                      <Button
                        variant="outline"
                        onClick={() => fileInputRef.current?.click()}
                      >
                        Select Files
                      </Button>
                    </Label>
                  </div>
                </div>
                <div className="bg-amber-50 border-2 border-amber-200 rounded-lg p-3">
                  <p className="text-xs text-amber-800">
                    Upload all processed visa documents for this batch
                  </p>
                </div>
              </div>
              <div className="flex items-center justify-end gap-3 mt-6">
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowUploadDialog(false);
                    setUploadingBatchId(null);
                    setBatchFiles([]);
                  }}
                  className="text-gray-900 hover:bg-gray-100"
                >
                  Cancel
                </Button>
                <Button
                  disabled={isUploading}
                  onClick={handleConfirmUpload}
                  style={{ backgroundColor: "#5B9BD5" }}
                  className="text-white hover:opacity-90 px-6"
                >
                  {isUploading ? (
                    <>
                      <Loader2 className="h-8 w-8 animate-spin" />
                      Uploading...
                    </>
                  ) : (
                    <>
                      <Upload className="w-4 h-4 mr-2" />
                      Confirm Upload
                    </>
                  )}
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Review & Approve Applicants Dialog */}
      {showReviewApproveDialog &&
        uploadingBatchId &&
        (() => {
          const batch = batches.find((b) => b.id === uploadingBatchId);
          if (!batch) return null;

          const selectedIds = batchSelections[uploadingBatchId] || [];
          const selectedApplicants = batch.applicants.filter(
            (app) =>
              selectedIds.includes(String(app.id)) && app.status === "uploaded",
          );
          const withCertificate = selectedApplicants.filter(
            (app) => app.certificateStatus === "found" || app.certificateFile,
          ).length;
          const missingCertificate = selectedApplicants.filter(
            (app) =>
              !app.certificateStatus ||
              app.certificateStatus === "pending" ||
              app.certificateStatus === "not_found",
          ).length;

          return (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <Card className="bg-white shadow-lg rounded-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
                <CardContent className="p-6">
                  {/* Header */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center">
                        <CheckCircle className="w-5 h-5 text-blue-600" />
                      </div>
                      <div>
                        <h2 className="text-lg font-semibold text-gray-900">
                          Review & Approve Applicants
                        </h2>
                        <p className="text-sm text-gray-600">
                          Review automatically detected visa certificates and
                          approve applicants
                        </p>
                      </div>
                    </div>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => {
                        setShowReviewApproveDialog(false);
                        setUploadingBatchId(null);
                      }}
                      className="h-8 w-8 p-0"
                    >
                      <X className="w-4 h-4" />
                    </Button>
                  </div>

                  {/* Summary Cards */}
                  <div className="grid grid-cols-3 gap-4 mb-6">
                    {/* Total Selected */}
                    <Card className="border-blue-200 bg-blue-50/30">
                      <CardContent className="p-4 text-center">
                        <div className="text-3xl font-bold text-blue-600 mb-1">
                          {selectedApplicants.length}
                        </div>
                        <div className="text-xs text-gray-600">
                          Total Selected
                        </div>
                      </CardContent>
                    </Card>

                    {/* With Certificate */}
                    <Card className="border-green-200 bg-green-50/30">
                      <CardContent className="p-4 text-center">
                        <div className="text-3xl font-bold text-green-600 mb-1">
                          {withCertificate}
                        </div>
                        <div className="text-xs text-gray-600">
                          With Certificate
                        </div>
                      </CardContent>
                    </Card>

                    {/* Missing Certificate */}
                    <Card className="border-orange-200 bg-orange-50/30">
                      <CardContent className="p-4 text-center">
                        <div className="text-3xl font-bold text-orange-600 mb-1">
                          {missingCertificate}
                        </div>
                        <div className="text-xs text-gray-600">
                          Missing Certificate
                        </div>
                      </CardContent>
                    </Card>
                  </div>

                  {/* Applicants List */}
                  <div className="space-y-3 mb-6">
                    {selectedApplicants.map((applicant) => {
                      const hasCertificate =
                        applicant.certificateStatus === "found" ||
                        applicant.certificateFile;

                      return (
                        <Card
                          key={applicant.id}
                          className={`border - 2 ${
                            hasCertificate
                              ? "border-green-200 bg-green-50/20"
                              : "border-orange-200 bg-orange-50/20"
                          } `}
                        >
                          <CardContent className="p-4">
                            <div className="flex items-start justify-between gap-4">
                              <div className="flex-1 space-y-2">
                                {/* Application Number and Status */}
                                <div className="flex items-center gap-3">
                                  <Badge
                                    variant="outline"
                                    className="bg-blue-50 text-blue-700 border-blue-200"
                                  >
                                    {applicant.applicationNo}
                                  </Badge>
                                  {hasCertificate ? (
                                    <Badge className="bg-green-50 text-green-600 border-green-200">
                                      <CheckCircle2 className="w-3 h-3 mr-1" />
                                      Certificate Found
                                    </Badge>
                                  ) : (
                                    <Badge className="bg-orange-50 text-orange-600 border-orange-200">
                                      <AlertCircle className="w-3 h-3 mr-1" />
                                      Missing
                                    </Badge>
                                  )}
                                </div>

                                {/* Applicant Details */}
                                <div>
                                  <p className="text-sm font-medium text-gray-900">
                                    {applicant.title} {applicant.firstName}{" "}
                                    {applicant.middleName} {applicant.lastName}
                                  </p>
                                  <p className="text-xs text-gray-600">
                                    ITS: {applicant.itsNumber} | Passport:{" "}
                                    {applicant.passportNo}
                                  </p>
                                </div>

                                {/* Visa Fee */}
                                <div className="text-xs text-gray-700">
                                  <span className="font-medium">Visa Fee:</span>{" "}
                                  ${applicant.visaCost}
                                </div>

                                {/* Certificate File */}
                                {hasCertificate && (
                                  <div className="flex items-center gap-2 text-xs text-green-700 bg-green-50 px-3 py-2 rounded-lg border border-green-200">
                                    <Paperclip className="w-3 h-3" />
                                    <span className="font-medium">
                                      Auto-detected:
                                    </span>
                                    <span>
                                      {applicant.certificateFile ||
                                        `${applicant.itsNumber}_${applicant.firstName} _visa.pdf`}
                                    </span>
                                  </div>
                                )}
                              </div>

                              {/* Action Buttons */}
                              <div className="flex flex-col gap-2">
                                {/* Preview Button */}
                                {hasCertificate && (
                                  <Button
                                    size="sm"
                                    variant="outline"
                                    className="border-green-300 text-green-700 hover:bg-green-50"
                                  >
                                    <Eye className="w-3.5 h-3.5 mr-1.5" />
                                    Preview
                                  </Button>
                                )}

                                {/* Upload Button for Missing Certificates */}
                                {!hasCertificate && (
                                  <label
                                    htmlFor={`cert - upload - ${applicant.id} `}
                                    className="cursor-pointer"
                                  >
                                    <div className="flex items-center gap-2 px-4 py-2 rounded-lg border-2 border-dashed border-orange-300 bg-orange-50 hover:bg-orange-100 transition-colors">
                                      <Upload className="w-4 h-4 text-orange-700" />
                                      <span className="text-xs text-orange-700 font-medium">
                                        Upload
                                      </span>
                                    </div>
                                    <input
                                      id={`cert - upload - ${applicant.id} `}
                                      type="file"
                                      accept=".pdf,.jpg,.jpeg,.png"
                                      className="hidden"
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (file) {
                                          handleCertificateUpload(
                                            String(applicant.id),
                                            file,
                                          );
                                        }
                                      }}
                                    />
                                  </label>
                                )}
                              </div>
                            </div>
                          </CardContent>
                        </Card>
                      );
                    })}
                  </div>

                  {/* Action Buttons */}
                  <div className="flex items-center justify-end gap-3">
                    <Button
                      variant="outline"
                      onClick={() => {
                        setShowReviewApproveDialog(false);
                        setUploadingBatchId(null);
                      }}
                      className="text-gray-900 hover:bg-gray-100"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={handleConfirmApproval}
                      style={{ backgroundColor: "#10B981" }}
                      className="text-white hover:opacity-90 px-6"
                    >
                      <CheckCircle className="w-4 h-4 mr-2" />
                      Confirm Approval
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          );
        })()}

      {/* No nore needed Confirmation Dialog */}
      <ConfirmDialog
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
        title="Confirm"
        description="Are you sure you want to Remove?"
        confirmText="Yes"
        loading={loading}
        onConfirm={confirmNoMoreNeeded}
        onCancel={cancelNoMoreNeeded}
      ></ConfirmDialog>
      {/* Delete Confirmation Dialog */}

      {/* Activity Logs Dialog */}
      {selectedApplicantForLogs && (
        <ActivityLogsPage
          visaId={selectedApplicantForLogs[0]?.visaApplicationId}
          statushisLoader={statushisLoader}
          selectedApplicantForLogs={selectedApplicantForLogs}
          open={showActivityLogs}
          onClose={() => {
            setShowActivityLogs(false);
            setSelectedApplicantForLogs([]);
          }}
        />
      )}
    </div>
  );
};
